<template>
  <div>
    <Dialog
      :header="$t('operacion.pagosCuenta.alta.titulo')"
      :modal="true"
      :visible.sync="displayModal"
      :contentStyle="{ overflow: 'visible' }"
      @hide="closeDialog"
    >
      <Errors v-show="this.errors.length > 0" :errors="this.errors" />

      <div class="p-grid p-fluid p-formgrid">
        <div class="p-col-12 p-md-6 p-field">
          <label for="fechaPago"
            ><b>{{ $t("operacion.pagosCuenta.fechaPago") }}</b></label
          >
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-calendar"></i>
            </span>
            <Calendar
              id="icon"
              v-model="pagoCuenta.fechaPago"
              dateFormat="dd/mm/yy"
              :showIcon="true"
              :showTime="false"
              :locale="getLocale"
            />
          </div>
        </div>

        <div class="p-col-12 p-md-6 p-field">
          <label for="importe"
            ><b>{{ $t("operacion.pagosCuenta.importe") }}</b></label
          >
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-money-bill"></i>
            </span>
            <InputText
              class="input"
              id="importe"
              type="text"
              v-model="pagoCuenta.importe"
              :placeholder="$t('operacion.pagosCuenta.placeHolders.importe')"
            />
          </div>
        </div>

        <div class="p-col-12 p-md-6 p-field">
          <label for="divisa"
            ><b>{{ $t("operacion.pagosCuenta.divisa") }}</b></label
          >
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-dollar"></i>
            </span>
            <InputText
              class="input"
              id="divisa"
              type="text"
              v-model="pagoCuenta.divisa"
              :placeholder="$t('operacion.pagosCuenta.placeHolders.divisa')"
              disabled="true"
            />
          </div>
        </div>
        <div class="p-col-12 p-md-6 p-field">
          <label for="referenciaCliente"
            ><b>{{ $t("operacion.pagosCuenta.referenciaCliente") }}</b></label
          >
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-id-card"></i>
            </span>
            <InputText
              class="input"
              id="referenciaCliente"
              type="text"
              v-model="pagoCuenta.referenciaCliente"
              :placeholder="
                $t('operacion.pagosCuenta.placeHolders.referenciaCliente')
              "
            />
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          @click.prevent="altaPagoCuenta()"
          :label="$t('common.buttons.save')"
          class=""
          icon="pi pi-save"
          iconPos="left"
        />
        <Button
          @click.prevent="closeDialog()"
          :label="$t('common.buttons.cancel')"
          class="p-button-secondary"
          icon="pi pi-times"
          iconPos="left"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import Errors from "@/components/utilidades/Errors.vue";
import { ALTA_PAGOS_CUENTA } from "@/graphQLQueries/OperacionQueries";

export default {
  name: "AltaPagoCuenta",
  props: ["operacionToken", "displayAlta"],
  components: {
    Errors: Errors,
  },
  data() {
    return {
      pagoCuenta: {
        divisa: "EUR",
      },
      displayModal: this.displayAlta,
      errors: [],
    };
  },
  created() {},
  methods: {
    altaPagoCuenta() {
      this.$apollo
        .mutate({
          mutation: ALTA_PAGOS_CUENTA,
          variables: {
            altaPagoCuentaRequest: {
              tokenOperacion: this.operacionToken,
              uuidUsuario: this.$store.state.profile.uuid,
              referenciaCliente: this.pagoCuenta.referenciaCliente,
              importe: this.pagoCuenta.importe,
              divisa: this.pagoCuenta.divisa,
              fecha: this.pagoCuenta.fechaPago,
            },
          },
        })
        .then(() => {
          this.closeDialog();
        })
        .catch((exception) => {
          this.errors = [];
          exception.graphQLErrors.forEach((error) => {
            this.errors.push(
              this.$i18n.t("operacion.pagosCuenta.errores." + error.message)
            );
          });
        });
    },
    closeDialog() {
      this.$emit("close-dialog", null);
      this.displayModal = false;
      this.errors = [];
    },
  },
  watch: {
    $route(to, from) {
      console.log(`${from} => ${to}`);
      this.show = false;
    },
  },
  computed: {
    getLocale() {
      return this.$i18n.t("calendar");
    },
  },
};
</script>

<style scoped>
.marginBottom {
  margin-bottom: 0.3cm;
  margin-top: 1cm;
}
</style>